import script from "./ShareMessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareMessageModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareMessageModal.vue?vue&type=style&index=0&id=5daf24fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5daf24fe"]])

export default __exports__